/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { FormattedMessage } from 'react-intl';

import { SecondaryButton, GroupThemedPrimaryButton } from '../Button';
import FlexRow from '../FlexRow';
import { ContentPanelFooter } from '../ContentPanel';
import { ContentDeleteButton } from '../TextLink';

interface Props {
  onCancel?(): void;
  onSubmit(data): void;
  isSubmitDisabled: boolean;
  submitPhrase: any;
  onCanvas?: boolean;
  onDelete?(): void;
  onDeleteText?: any;
}

const SubmitFormControls = (props: Props) => {
  return (
    <ContentPanelFooter onCanvas={props.onCanvas}>
      <FlexRow>
        <div>
          {
            props.onDelete && (
              <ContentDeleteButton onClick={props.onDelete}>
                {props.onDeleteText}
              </ContentDeleteButton>
            )
          }
        </div>

        <FlexRow>
          {
            props.onCancel && (
              <SecondaryButton
                onClick={props.onCancel}
              >
                <FormattedMessage id="nav.cancel.button.label" />
              </SecondaryButton>
            )
          }

          <GroupThemedPrimaryButton
            onClick={props.onSubmit}
            isDisabled={props.isSubmitDisabled}
            style={{ marginLeft: 24 }}
            type="submit"
          >
            <FormattedMessage {...props.submitPhrase} />
          </GroupThemedPrimaryButton>
        </FlexRow>

      </FlexRow>
    </ContentPanelFooter>
  );
}

interface CancelFormControlProps {
  onCancel?(): void;
  onSubmit(data): void;
  isSubmitDisabled: boolean;
  onCanvas?: boolean;
  onDelete?(): void;
  onDeleteText?: any;
}

export const CancelUpdateFormControls = (props: CancelFormControlProps) => (
  <SubmitFormControls {...props} submitPhrase={{ id: 'nav.update.button.label' }} onCanvas={true} />
);

export const CancelSubmitFormControls = (props: CancelFormControlProps) => (
  <SubmitFormControls {...props} submitPhrase={{ id: 'nav.submit.button.label' }} />
);

export default SubmitFormControls;
